var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 2.88,
    fill: "#FAAD14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.44531 11.713L15.5425 8.48535",
    stroke: "white",
    strokeWidth: 0.617143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2156 7.98535L15.5424 8.48524L15.0487 9.81209",
    stroke: "white",
    strokeWidth: 0.617143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8572 16.0146H14.3143V11.6946C14.3143 11.6128 14.3468 11.5343 14.4047 11.4765C14.4626 11.4186 14.5411 11.3861 14.6229 11.3861H15.5486C15.6304 11.3861 15.7089 11.4186 15.7668 11.4765C15.8247 11.5343 15.8572 11.6128 15.8572 11.6946V16.0146Z",
    stroke: "white",
    strokeWidth: 0.617143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7715 16.0146H11.2286V12.6204C11.2286 12.5385 11.2611 12.46 11.319 12.4022C11.3769 12.3443 11.4554 12.3118 11.5372 12.3118H12.4629C12.5448 12.3118 12.6232 12.3443 12.6811 12.4022C12.739 12.46 12.7715 12.5385 12.7715 12.6204V16.0146Z",
    stroke: "white",
    strokeWidth: 0.617143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.68555 16.0146H8.14269V13.5461C8.14269 13.4642 8.1752 13.3858 8.23307 13.3279C8.29094 13.27 8.36942 13.2375 8.45126 13.2375H9.37698C9.45881 13.2375 9.5373 13.27 9.59517 13.3279C9.65304 13.3858 9.68555 13.4642 9.68555 13.5461V16.0146Z",
    stroke: "white",
    strokeWidth: 0.617143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiIcon);
export default __webpack_public_path__ + "static/media/bi_icon.e256a88773e5410ddc57cc6492d3a535.svg";
export { ForwardRef as ReactComponent };